const globals = require('../../../../js_functions/globalsWrapper')();

const baseUrl = (globals.equipmentsBaseURL || `${window.location.protocol}` + '//' +`${window.location.hostname}:8001`) + '/api/public/equipment';
const me = require('../../../../js_functions/me');
let currentSearch = null;
let currentSearchField = null;
let metadata = null;
const noOfRows = 10;
const APIVersion = 2;

function ajaxCall(config) {
    const ajaxConfig = Object.assign({
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json; charset=utf-8',
        }
    }, config);

    return new Promise((resolve, reject) => {
        $.ajax(ajaxConfig)
            .done(resolve)
            .fail(reject);
    });
}

async function getEquipmentSearchResults(searchString, searchField, offset = 0) {
    currentSearch = searchString;
    currentSearchField = searchField;

    const data = {
        searchString,
        searchField,
        offset,
        noOfRows,
    };

    if (globals.medicationsLocationFilteringEnabled) {
        const user = await me.get();

        if (!user.data.hospital) {
            return {
                invalidLocation: true,
            };
        }

        data.locationFilter = user.data.hospital;
    }

    return ajaxCall({
        url: baseUrl,
        type: 'GET',
        data: data,
    }).then(response => {
        metadata = response.metadata;

        return response.data.reduce((equipmentIDMapping, equipment) => {
            equipmentIDMapping[equipment.uuid] = Object.assign(equipment, { id: equipment.uuid});
            return equipmentIDMapping;
        }, {});
    });
}

function hasPreviousPage() {
  return metadata.page > 0;
}

async function previousPage() {
  return getEquipmentSearchResults(currentSearch, currentSearchField, Math.max(0, metadata.page - 1));
}

function hasNextPage() {
  return metadata.total / noOfRows > metadata.page + 1;
}

async function nextPage() {
    return getEquipmentSearchResults(currentSearch, currentSearchField, metadata.page + 1);
}

module.exports = {
    APIVersion,
    getEquipmentSearchResults,
    hasPreviousPage,
    hasNextPage,
    nextPage,
    previousPage,
};
